export default "__VITE_ASSET__DJnknokb__"